<template>
    <div
        class="banner-mini"
        :class="{'banner-mini--mob-image': imageMob}"
        :style="{'background-image': `${bgImage ? bgImage : ''}`}"
    >
        <div class="banner-mini__content" :class="{'_text-below' : textBelowMobile}">
            <slot name="content"></slot>
        </div>
        <div v-if="$slots.button" class="banner-mini__button">
            <slot name="button"></slot>
        </div>
        <div v-if="(!isMob && image) || (isMob && imageMob)"
            :style="`background-image: url(${isMob && imageMob ? imageMob : isMob && !imageMob ? '' : image })`"
             class="banner-mini__image"></div>
    </div>
</template>

<script>
import isMob from "../../assets/js/vue/mixins/isMob"

export default {
    name: 'BannerMini',
    mixins: [isMob],
    props: {
        bgImage: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
        imageMob: {
            type: String,
            default: '',
        },
        textBelowMobile: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        isMob() {
            return this.windowWidth <= 1000;
        }
    },
}

</script>

<style lang="scss" scoped>

@import '../../assets/scss/base/_variables.scss';
@import '../../assets/scss/base/_mixins.scss';
@import '../../assets/scss/base/_functions.scss';

$b: '.banner-mini';

#{$b} {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    align-items: center;
    @include fluid('height', 128px, auto);
    @include fluid('padding-top', 0, 24px);
    @include fluid('padding-right', 56px, 16px);
    @include fluid('padding-bottom', 0, 24px);
    @include fluid('padding-left', 312px, 16px);
    @include fluid('border-radius', 32px, 24px);
    background-color: $grey-109;
    background-size: contain;
    background-repeat: no-repeat;
    overflow: hidden;

    @include mobile {
        flex-direction: column;
    }

    &__image {
        position: absolute;
        top: 0;
        background-size: contain;
        background-position: bottom;
        background-repeat: no-repeat;
        @include fluid('left', 56px, 0);
        @include fluid('width', 240px);
        @include fluid('height', 128px);

        @include mobile {
            width: 100%;
            height: 100%;
        }
    }

    &--mob-image {
        @include fluid('height', 128px, 320px);
    }

    &__content {
        z-index: 1;

        &._text-below {

            @include mobile {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                height: 100%;
            }
        }
    }

    &__button {
        z-index: 1;
        @include fluid('margin-top', 0, 16px);
        @include fluid('margin-left', 32px, 0);

        @include mobile {
            width: 100%;
        }
    }
}

</style>
